import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-navbar',
  templateUrl: './help-navbar.component.html',
  styles: []
})
export class HelpNavbarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
